import SkillDto from '@/models/Skills/SkillDto';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';
import UniformDto from '@/models/Uniforms/UniformDto';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import DeskDto from '@/models/Desks/DeskDto';
import QualificationDto from '@/models/Qualifications/QualificationDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';

export default class BookingRoleViewModel {
    id = '';
    owner: AgencyUserDto = new AgencyUserDto();
    contactLocation: ContactLocationDto = new ContactLocationDto();
    quantity = 1;
    startAtTime = '08:00'
    endAtTime = '14:00';
    rateCardPosition: RateCardPositionDto = new RateCardPositionDto();
    chargeRate = 0;
    positionDescription = '';
    desk: DeskDto = new DeskDto();
    uniform: UniformDto = new UniformDto();
    uniformDescription ='';
    skills: SkillDto[] = [];
    qualifications: QualificationDto[] = [];
    shifts: ShiftViewModel[] = [];
}